import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import { submit } from 'redux-form'
import requestDeleteRoom from '../../../actions/bookingCalendar/room/requestDeleteRoom'
import {
  requestNextRoom,
  requestPrevRoom,
} from '../../../actions/bookingCalendar/room/requestUpdateRoom'
import { IStore } from '../../../reducers'
import { findEventsForOpenModal } from '../../../reducers/bookingCalendar/selectors/events'
import {
  getRoomIdFromOpenModal,
  getRoomModalIsSaving,
} from '../../../reducers/bookingCalendar/selectors/getModalOpen'
import { findRoomForOpenModal } from '../../../reducers/bookingCalendar/selectors/rooms'
import { FormNames } from '../../Form/CreateRoom'
import closeModal from '../../../actions/Modals/closeModal'
import openModal from '../../../actions/Modals/openModal'
import { IRoomModalDispatch, IRoomModalProps } from './RoomModal'

const mapStateToProps = () => {
  const findRoom = findRoomForOpenModal
  const findEvents = findEventsForOpenModal
  const getRoom = getRoomIdFromOpenModal

  return (state: IStore, ownProps): IRoomModalProps => {
    const roomId = getRoom(state)
    const room = findRoom(roomId ? roomId : ownProps.roomId)(state)
    const events = findEvents(roomId ? roomId : ownProps.roomId)(state)

    return {
      booking: room.booking,
      events: events.length,
      iCalendar: room.iCalendar,
      isSaving: getRoomModalIsSaving(state),
      roomId: room ? room.id : '0',
      type: 'update',
    }
  }
}

const bindDispatchToProps = (
  dispatch: Dispatch,
  ownProps,
): IRoomModalDispatch => ({
  deleteRoom() {
    dispatch(requestDeleteRoom(ownProps.roomId))
  },
  modalClose(id) {
    dispatch(closeModal(id))
  },
  modalOpen(id, element) {
    dispatch(openModal(id, element))
  },
  nextRoom() {
    dispatch(requestNextRoom(ownProps.roomId))
  },
  prevRoom() {
    dispatch(requestPrevRoom(ownProps.roomId))
  },
  submitForm() {
    dispatch(submit(FormNames.Update))
  },
})

export default connect<IRoomModalProps, IRoomModalDispatch, any>(
  mapStateToProps(),
  bindDispatchToProps,
)
